document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll(".submenu-toggle").forEach(function (button) {

        button.addEventListener("click", function (e) {

            e.preventDefault();
            e.stopPropagation();

            let submenu = this.parentElement.parentElement.querySelector(".mob-submenu");

            if (!submenu) return;

            document.querySelectorAll(".mob-submenu").forEach(function (item) {

                if (item !== submenu) {
                    item.style.display = "none";
                }

            });

            submenu.style.display =
                submenu.style.display === "block" ? "none" : "block";

        });

    });

});